import React, { useState, useEffect, useMemo, useRef } from "react";
import { Button, Checkbox, Dropdown, Form } from "semantic-ui-react";
import CardLayout from "react-lib/apps/common/CardLayout";
import RightLabel from "react-lib/apps/common/RightLabel";


import ReactTable from "react-table-6";
import { useIntl } from "react-intl";

interface CardPatientSearchCUProps {
 hnPreData?: string;
 patientList?: any[];
 nationalitiesList?: any[];
 getPatientList?: (data) => void;
 getNationality?: () => void;
 hideCallBack?: () => void;
 onSelectPatient?: (id, hn, full_name, original) => void;
 onOpenModPatientOldName?: (id, hn, full_name) => void;
 onPaginationChange?: (data) => void;
 currentPage?: number;
 hideColumnsByAccessor?: any[];
 inputChangeAutoSearch?: boolean;
 systemHn8Digit?: boolean;
 formatHn8Digit?: (hnData) => any;
 numberOfPage: number;
 patientListLoading: boolean;
 isAPILoading: boolean;
}

const CardPatientSearchCU = ({
  hnPreData = "",
  getPatientList = () => {},
  getNationality = () => {},
  hideCallBack = () => {},
  onSelectPatient = () => {},
  nationalitiesList = [],
  patientList = [],
  onOpenModPatientOldName = () => {},
  numberOfPage,
  currentPage = 1,
  onPaginationChange = () => {},
  patientListLoading,
  isAPILoading,
  hideColumnsByAccessor = [],
  inputChangeAutoSearch = false,
  systemHn8Digit = false,
  formatHn8Digit = () => {},
}: CardPatientSearchCUProps) => {
  const intl = useIntl();
  const [hn, setHn] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [citizenId, setCitizenId] = useState("");
  const [nationality, setNationality] = useState<any>(null);
  const [startAge, setStartAge] = useState("");
  const [endAge, setEndAge] = useState("");
  const [birthInfo, setBirthInfo] = useState("dmy");
  const [birthDate, setBirthDate] = useState("");
  const [noEncounter, setNoEncounter] = useState(false);
  const [mergeFile, setMergeFile] = useState(false);
  const [isEmergency, setIsEmergency] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [patientResult, setPatientResult] = useState<any[]>([]);

  const [clickTimeout, setClickTimeout] = useState<any>(null); // to distinguish between single click and double click
  const [patientSelected, setPatientSelected] = useState<any>(null);

  const styles = {
    mainTable: { height: 420, backgroundColor: "#ffffff", overflowX: "auto" },
  };

  const currentChange = useRef<number>(0);
  const isMounted = useRef(false);

  const handleOnClear = () => {
    setHn("");
    setFirstName("");
    setLastName("");
    setCitizenId("");
    setNationality(null);
    setPatientResult([]);
  };

  const handleOnSearch = async (hnparam = "") => {
    // hnparam อาจเป็นชื่อเข้ามาด้วย

    let hnData = hnparam || hn

    if (systemHn8Digit) {
      if (/^\d+$/.test(hnData?.trim())) {
        hnData = formatHn8Digit(hnData);
      }
    }

    if (typeof hnData !== "string") {
      return;
    }

    let [birthDateFormat, showADBirthDate] = birthDateFormatAD(birthDate);

    let hnSearch = hnData;
    let firstNameSearch = firstName;
    let lastNameSearch = lastName;

    if (!/\d/.test(hnData) && hnparam) {
      firstNameSearch = hnparam
      hnSearch = hn
    }

    await getPatientList({
      hn: hnSearch,
      firstName: firstNameSearch,
      lastName: lastNameSearch,
      citizenId: citizenId,
      nationality: nationality,
      startAge: startAge,
      endAge: endAge,
      noEncounter: noEncounter,
      mergeFile: mergeFile,
      includeCancel: mergeFile ? true : false,
      isEmergency: isEmergency,
      birthdate: birthDateFormat,
      showADBirthDate: showADBirthDate,
      patientCurrentPage: 1,
    });

    setIsLoading(false);
  };

  const birthDateFormatAD = (birthRecord = "") => {
    let isADYear = true
    if (!birthRecord) {
      return [birthRecord, false];
    }
    let birthSubString = birthRecord.split("/");
    if ((birthInfo === "dmy" && birthSubString.length < 3) || (birthInfo === "my" && birthSubString.length < 2)) {
      return [birthRecord, false];
    }

    let year = birthInfo === "dmy" ? birthSubString[2] : birthInfo === "my" ? birthSubString[1] : birthSubString[0];
    let yearAD = +year;
    if (+year > 2400) {
      yearAD = yearAD - 543;
      isADYear = false
    }

    if (birthInfo === "dmy") {
      return [`${yearAD}-${birthSubString[1]}-${birthSubString[0]}`, isADYear];
    } else if (birthInfo === "my") {
      return [`${yearAD}-${birthSubString[0]}`, isADYear];
    } else {
      return [yearAD, isADYear];
    }
  };

  useEffect(() => {
    getNationality();
  }, []);

  useEffect(() => {
    setPatientResult(patientList);
  }, [patientList]);

  useEffect(() => {
    isMounted.current = true;

    if (/\d/.test(hnPreData)) {
      setHn(hnPreData);
    } else {
      setFirstName(hnPreData)
    }

    if (hnPreData) {
      handleOnSearch(hnPreData);
    }
  }, [hnPreData]);

  useEffect(() => {
    if (isMounted.current && inputChangeAutoSearch && firstName.length >= 3) {
      currentChange.current += 1;
      handleAutoSearch();
    }
  }, [firstName]);

    useEffect(() => {
    if (isMounted.current && inputChangeAutoSearch && lastName.length >= 3) {
      currentChange.current += 1;
      handleAutoSearch();
    }
  }, [lastName]);

  useEffect(() => {
    const inputJumpToPage = document.querySelector(".-pageJump input") as HTMLElement;
    const handleChaneJumpToPage = (e: any) => {
      handlePageChange(e.target.valueAsNumber - 1);
    };
    if (inputJumpToPage) {
      inputJumpToPage.addEventListener("change", handleChaneJumpToPage);
    }
    return () => {
      if (inputJumpToPage) {
        inputJumpToPage.removeEventListener("change", handleChaneJumpToPage);
      }
    };
  }, []);

  const handleAutoSearch = async (hn = "") => {
    const promise = (number: any) => {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(number);
        }, 500);
      });
    };
    promise(currentChange.current).then((res) => {
      if (currentChange.current === res) {
        handleOnSearch();
      }
    });
  };

  const handleOnChangeHN = (e: any) => {
    setHn(e.target.value);
  };

  const handleOnChangeFirstName = (e: any, data: any) => {
    if (patientListLoading) {
      return;
    }
    setFirstName(data.value);
  };

  const handleOnChangeLastName = (e: any, data: any) => {
    if (patientListLoading) {
      return;
    }
    setLastName(data.value);
  };

  const handleOnChangeCitizenID = (e: any) => {
    setCitizenId(e.target.value);
  };

  const handleOnChangeNation = (e: any, { value }: any) => {
    setNationality(value);
  };

  const handleOnChangeBirthType = (e: any, { value }: any) => {
    setBirthInfo(value);
  };

  const handleOnChangeBirthDate = (e: any) => {
    setBirthDate(e.target.value);
  };

  const handleChangeStartAge = (e: any) => {
    setStartAge(e.target.value);
  };

  const handleChangeEndAge = (e: any) => {
    setEndAge(e.target.value);
  };

  const handleCheckNoEncounter = (e: any, data: any) => {
    setNoEncounter(data.checked);
  };

  const handleCheckMergeFile = (e: any, data: any) => {
    setMergeFile(data.checked);
  };

  const handleCheckIsEmergency = (e: any, data: any) => {
    setIsEmergency(data.checked);
  };

  const handleOnSelectPatient = () => {
    if (patientSelected) {
      onSelectPatient(patientSelected.original.id, patientSelected.original.hn, patientSelected.original.full_name, patientSelected.original);
      // hideCallBack();
    }
  };

  const handlePageChange = async (page: any) => {
    let [birthDateFormat, showADBirthDate] = birthDateFormatAD(birthDate);

    setIsLoading(true);
    await onPaginationChange({
      hn: hn,
      firstName: firstName,
      lastName: lastName,
      citizenId: citizenId,
      nationality: nationality,
      startAge: startAge,
      endAge: endAge,
      noEncounter: noEncounter,
      mergeFile: mergeFile,
      isEmergency: isEmergency,
      birthdate: birthDateFormat,
      showADBirthDate: showADBirthDate,
      patientCurrentPage: page + 1,
    });
    console.log("handlePageChange False");
    setIsLoading(false);
  };

  const handleOnKeyPressHN = async (ev: any) => {
    let hn = ev.target.value.toUpperCase();
    if (ev.key === "Enter") {
      if (inputChangeAutoSearch) {
        handleOnSearch(hn);
      }
    }
  };

  const allGridColumns = useMemo(
    () => [
      {
        Header: "HN",
        minWidth: 100,
        Cell: (data: any) => {
          return <div style={{ color: !!data.original.canceled ? "red" : "black" }}>{data.original.hn}</div>;
        },
      },
      {
        Header: "ID / Passport",
        minWidth: 140,
        Cell: (data: any) => {
          return <div style={{ color: !!data.original.canceled ? "red" : "black" }}>{data.original.citizen_passport}</div>;
        },
      },
      {
        Header: "ชื่อ นามสกุล (ไทย)",
        minWidth: 170,
        Cell: (data: any) => {
          return <div style={{ color: !!data.original.canceled ? "red" : "black" }}>{data.original.full_name_th}</div>;
        },
      },
      {
        Header: "ชื่อ นามสกุล (อังกฤษ)",
        minWidth: 170,
        Cell: (data: any) => {
          return <div style={{ color: !!data.original.canceled ? "red" : "black" }}>{data.original.full_name_en}</div>;
        },
      },
      {
        Header: "วันเดือนปีเกิด",
        minWidth: 100,
        Cell: (data: any) => {
          return <div style={{ color: !!data.original.canceled ? "red" : "black" }}>{data.original.birthdate}</div>;
        },
      },
      {
        Header: "ชื่อมารดา",
        minWidth: 170,
        Cell: (data: any) => {
          return <div style={{ color: !!data.original.canceled ? "red" : "black" }}>{data.original.mother}</div>;
        },
      },
      {
        Header: "สถานะ",
        minWidth: 150,
        Cell: (data: any) => {
          return <div style={{ color: !!data.original.canceled ? "red" : "black" }}>{data.original.canceled_reason}</div>;
        },
      },
      {
        Header: "ชื่อเดิม",
        style: { whiteSpace: "unset", textAlign: "center" },
        minWidth: 80,
        Cell: (data: any) => {
          if (data.original.old_name) {
            return <Button color="blue" icon="search" onClick={() => onOpenModPatientOldName(data.original.id, data.original.hn, data.original.full_name)} />;
          }
          return "";
        },
      },
    ],
    []
  );

  const gridColumns = useMemo(() => {
    const columns = [...allGridColumns];
    return columns.filter((col: any) => !(hideColumnsByAccessor || [])?.includes(col.accessor));
  }, []);

  // console.log(gridColumns);

  return (
    <CardLayout titleText="ค้นหาผู้ป่วย" onClose={hideCallBack} toggleable={false} loading={patientListLoading}>
      <Form>
        <Form.Group inline>
          <Form.Field >
            <RightLabel>HN</RightLabel>
          </Form.Field>
          <Form.Input width={3} onChange={handleOnChangeHN} value={hn} onKeyPress={handleOnKeyPressHN} />
          <Form.Field >
            <RightLabel>{intl.formatMessage({ id: "ชื่อ" })}</RightLabel>
          </Form.Field>
          <Form.Input width={3} onChange={handleOnChangeFirstName} value={firstName} />
          <Form.Field >
            <RightLabel>{intl.formatMessage({ id: "นามสกุล" })}</RightLabel>
          </Form.Field>
          <Form.Input width={3} onChange={handleOnChangeLastName} value={lastName} />
        </Form.Group>

        <Form.Group inline>
          <Form.Field>
            <RightLabel>ID/Passport</RightLabel>
          </Form.Field>
          <Form.Input width={2} onChange={handleOnChangeCitizenID} value={citizenId} />
          <Form.Field >
            <RightLabel>{intl.formatMessage({ id: "สัญชาติ" })}</RightLabel>
          </Form.Field>
          <Form.Field width={3}>
            <Dropdown
              className="fluidDropdown"
              search
              selection
              clearable
              fluid
              placeholder="ทุกสัญชาติ"
              options={nationalitiesList}
              value={nationality}
              onChange={handleOnChangeNation}
              style={{ width: "100%" }}
            />
          </Form.Field>
          <Form.Field inline style={{ minWidth: "max-content" }}>
            <RightLabel>{intl.formatMessage({ id: "ระบุช่วงอายุ" })}</RightLabel>
          </Form.Field>
          <Form.Field inline width={3} style={{ paddingRight: "0px" }}>
            <Form style={{ width: "100%" }}>
              <Form.Group inline style={{ margin: 0 }}>
                <Form.Input width={7} onChange={handleChangeStartAge} value={startAge} />
                <Form.Field width={2}>
                  <b>-</b>
                </Form.Field>
                <Form.Input width={7} onChange={handleChangeEndAge} value={endAge} />
              </Form.Group>
            </Form>
          </Form.Field>
          <Form.Field width={2}>
            <RightLabel>
              <Dropdown
                // className="fluidDropdown"
                // search
                // selection
                // clearable
                // placeholder="ทุกสัญชาติ"
                options={[
                  { key: "1b", text: "วันเดือนปีเกิด", value: "dmy" },
                  { key: "2b", text: "เดือนปีเกิด", value: "my" },
                  { key: "3b", text: "ปีเกิด", value: "y" },
                ]}
                value={birthInfo}
                onChange={handleOnChangeBirthType}
              />
            </RightLabel>
          </Form.Field>
          <Form.Input
            placeholder={birthInfo === "dmy" ? "DD/MM/YYYY" : birthInfo === "my" ? "MM/YYYY" : "YYYY"}
            width={2}
            onChange={handleOnChangeBirthDate}
            value={birthDate}
          />
        </Form.Group>

        <Form.Group inline>
          <Form.Field width={2}></Form.Field>
          <Form.Field width={3}>
            <Checkbox label="เฉพาะผู้ป่วยใหม่" checked={noEncounter} onChange={handleCheckNoEncounter} />
          </Form.Field>
          <Form.Field width={3}>
            <Checkbox label="ผู้ป่วยที่มีการโอนแฟ้ม" checked={mergeFile} onChange={handleCheckMergeFile} />
          </Form.Field>
          <Form.Field width={3}>
            <Checkbox label="ผู้ป่วยฉุกเฉิน" checked={isEmergency} onChange={handleCheckIsEmergency} />
          </Form.Field>
          <Form.Field width={1}></Form.Field>
          <Form.Button width={2} fluid color="blue" onClick={() => handleOnSearch()}>
            ค้นหา
          </Form.Button>
          <Form.Button width={2} fluid color="teal" onClick={handleOnClear}>
            Clear
          </Form.Button>
        </Form.Group>
      </Form>

      <ReactTable
        style={styles.mainTable}
        manual
        sortable={false}
        data={patientResult}
        pageSize={patientList ? (patientList.length < 10 ? 10 : patientList.length) : 10}
        showPageSizeOptions={false}
        page={currentPage - 1}
        pages={numberOfPage}
        onPageChange={handlePageChange}
        loading={isLoading || isAPILoading}
        getNoDataProps={() => {
          return { style: { display: "none" } };
        }}
        getTrProps={(state: any, rowInfo: any) => {
          if (rowInfo && rowInfo.row) {
            let background = rowInfo.index === (patientSelected ? patientSelected.index : null) ? "#CCE2FF" : "white";
            return {
              onClick: (e: any) => {
                setPatientSelected(rowInfo);
                if (clickTimeout !== null) {
                  if ((patientSelected ? patientSelected.index : null) === rowInfo.index) {
                    clearTimeout(clickTimeout);
                    setClickTimeout(null);
                    onSelectPatient(rowInfo.original.id, rowInfo.original.hn, rowInfo.original.full_name, rowInfo.original);
                    // hideCallBack();
                  }
                } else {
                  setClickTimeout(
                    setTimeout(() => {
                      clearTimeout(clickTimeout);
                      setClickTimeout(null);
                    }, 500)
                  );
                }
              },
              style: {
                background: background,
              },
            };
          } else {
            return {};
          }
        }}
        columns={gridColumns}
      ></ReactTable>
      <br />
      <Button color="blue" onClick={handleOnSelectPatient}>{intl.formatMessage({ id: "เลือก" })}</Button>
    </CardLayout>
  );
};


export default React.memo(CardPatientSearchCU);
